"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeEventType = void 0;
var ExchangeEventType;
(function (ExchangeEventType) {
    // MODULE:CORE
    ExchangeEventType["Purchase"] = "Purchase";
    // MODULE:CLAIM
    ExchangeEventType["Claim"] = "Claim";
    // MODULE:CRAFT
    ExchangeEventType["Craft"] = "Craft";
    ExchangeEventType["Dismantle"] = "Dismantle";
    // MODULE:LOOT
    ExchangeEventType["PurchaseLootBox"] = "PurchaseLootBox";
    // MODULE:MYSTERY
    ExchangeEventType["PurchaseMysteryBox"] = "PurchaseMysteryBox";
    // MODULE:METADATA
    ExchangeEventType["UpdMetadata"] = "UpdMetadata";
    // MODULE:DISCRETE
    ExchangeEventType["Upgrade"] = "Upgrade";
    // MODULE:LOTTERY
    ExchangeEventType["PurchaseLottery"] = "PurchaseLottery";
    // MODULE:RAFFLE
    ExchangeEventType["PurchaseRaffle"] = "PurchaseRaffle";
    // MODULE:BREEDING
    ExchangeEventType["Breed"] = "Breed";
    // MODULE:RENTABLE
    ExchangeEventType["Lend"] = "Lend";
    // MODULE:MERGE
    ExchangeEventType["Merge"] = "Merge";
    // MODULE:PAYMENT_SPLITTER
    ExchangeEventType["PayeeAdded"] = "PayeeAdded";
    ExchangeEventType["PaymentReleased"] = "PaymentReleased";
    ExchangeEventType["PaymentReceived"] = "PaymentReceived";
    ExchangeEventType["ERC20PaymentReleased"] = "ERC20PaymentReleased";
})(ExchangeEventType || (exports.ExchangeEventType = ExchangeEventType = {}));
//# sourceMappingURL=exchange.js.map